
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-social-link',
  imports: [],
  templateUrl: './social-link.component.html',
  styleUrl: './social-link.component.scss'
})
export class SocialLinkComponent {
  @Input() url: string = '';
  @Input() icon: string = '';
  @Input() type: string = '';
}
